export const paginationPageWindow = (
  current: number,
  total: number,
  range = 1
): number[] => {
  const pages = new Set<number>();
  for (let i = current - range; i <= current + range; i += 1) {
    if (i >= 1 && i <= total) pages.add(i);
  }
  return Array.from(pages).sort((a, b) => a - b);
};